import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment as env } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  private token: string;

  constructor(private http: HttpClient) {}

  public getParameterValue(parameterKey: string): Observable<any> {
    const token = JSON.parse(localStorage.getItem("app_storage"))?.tokenClaims;
    return this.http.get(
      `${env.gateway.base_url}/cauth/api/turbo/pa/parameter/by-key/${parameterKey}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "text/plain;charset=UTF-8",
        },
      }
    );
  }
}
